import React, { FC } from "react";
import { Text, TextProps } from "@UI/Components/Text/Text";
import { Bold } from "@UI/Components/Bold/Bold";
import { RateProps } from "../Rate/Rate";
import { FormattedTimeUnit } from "@I18n/Components/FormattedTimeUnit/FormattedTimeUnit";
import useMediaQuery from "@UI/hooks/useMediaQuery";
import { FormattedNumber } from "@I18n/Components/FormattedNumber/FormattedNumber";
import { Box } from "@UI/Components/Box/Box";
import { Flex } from "@UI/Components/Flex/Flex";

interface Props {
  moneyFontSize?: TextProps["fontSize"];
}

export const PrettyRate: FC<RateProps & Props> = ({
  cents,
  unit,
  currency,
  moneyFontSize = "md",
}) => {
  const { isMobile } = useMediaQuery();

  const moneyPart = (
    <FormattedNumber
      value={cents / 100}
      style="currency"
      currency={currency}
      minimumFractionDigits={0}
    />
  );

  if (unit === "flat") {
    return <Bold fontSize={moneyFontSize}>{moneyPart}</Bold>;
  }

  const timeUnit = (
    <FormattedTimeUnit unit={unit} format={isMobile ? "short" : "long"} />
  );

  return (
    <Flex alignItems="flex-end">
      <Bold lineHeight="1" display="block" fontSize={moneyFontSize}>
        {moneyPart}
      </Bold>
      <Text
        as="span"
        fontWeight="light"
        color="gray.700"
        whiteSpace="nowrap"
        fontSize="sm"
      >
        <Box as="span" px="1">
          /
        </Box>
        {timeUnit}
      </Text>
    </Flex>
  );
};
